import React from 'react'
// eslint-disable-next-line import/named
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'
import { COLORS } from '../styles/variables'

export const IconAddProject: React.FC<SvgIconProps> = (props) => (
  <SvgIcon
    viewBox="0 0 24 24"
    sx={{
      color: COLORS.CERULEAN,
    }}
    {...props}
  >
    <path 
        d="M10.97 18.37H7.36C6.67 18.37 6.08 17.79 6.08 17.09V5.03C6.08 4.34 6.66 3.75 7.36 3.75H14.91C15.6 3.75 16.19 4.33 16.19 5.03V12.58C16.46 12.53 16.72 12.53 17.04 12.53C17.36 12.53 17.62 12.58 17.94 12.58V5.03C17.94 3.38 16.61 2 14.91 2H7.36C5.71 2 4.33 3.33 4.33 5.03V17.1C4.33 18.75 5.66 20.13 7.36 20.13H11.19C11.08 19.65 10.98 19.12 10.98 18.59V18.38L10.97 18.37Z" 
        stroke="none"
        fill="currentColor"
    />
    <path 
        d="M16.98 14.07C14.53 14.07 12.51 16.09 12.51 18.54C12.51 20.99 14.53 23 16.98 23C19.43 23 21.44 20.98 21.44 18.54C21.44 16.1 19.47 14.07 16.98 14.07ZM16.98 21.72C15.23 21.72 13.79 20.28 13.79 18.53C13.79 16.78 15.23 15.34 16.98 15.34C18.73 15.34 20.17 16.77 20.17 18.53C20.17 20.29 18.73 21.72 16.98 21.72Z" 
        stroke="none"
        fill="currentColor"
    />
    <path 
        d="M18.52 18H17.51V16.99C17.51 16.72 17.3 16.46 16.98 16.46C16.66 16.46 16.45 16.67 16.45 16.99V18H15.44C15.17 18 14.91 18.21 14.91 18.53C14.91 18.85 15.12 19.06 15.44 19.06H16.45V20.07C16.45 20.34 16.66 20.6 16.98 20.6C17.3 20.6 17.51 20.39 17.51 20.07V19.06H18.52C18.79 19.06 19.05 18.85 19.05 18.53C19.05 18.21 18.84 18 18.52 18Z" 
        stroke="none"
        fill="currentColor"
    />
    <path 
        d="M14.16 5.35H8.05C7.68 5.35 7.41 5.62 7.41 5.99C7.41 6.36 7.68 6.63 8.05 6.63H14.16C14.53 6.63 14.8 6.36 14.8 5.99C14.8 5.62 14.53 5.35 14.16 5.35Z"
        stroke="none"
        fill="currentColor"
    />
    <path 
        d="M14.16 7.95H8.05C7.68 7.95 7.41 8.22 7.41 8.59C7.41 8.96 7.68 9.23 8.05 9.23H14.16C14.53 9.23 14.8 8.96 14.8 8.59C14.8 8.22 14.53 7.95 14.16 7.95Z" 
        stroke="none"
        fill="currentColor"
    />
    <path 
        d="M14.16 10.5H8.05C7.68 10.5 7.41 10.77 7.41 11.14C7.41 11.51 7.68 11.78 8.05 11.78H14.16C14.53 11.78 14.8 11.51 14.8 11.14C14.8 10.77 14.53 10.5 14.16 10.5Z"
        stroke="none"
        fill="currentColor"
    />
    <path 
        d="M12.03 13.11H8.10001C7.73001 13.11 7.46001 13.38 7.46001 13.75C7.46001 14.12 7.73001 14.39 8.10001 14.39H12.03C12.4 14.39 12.67 14.12 12.67 13.75C12.67 13.38 12.4 13.11 12.03 13.11Z"
        stroke="none"
        fill="currentColor"
    />
  </SvgIcon>
)
